import { useTranslation } from "react-i18next"
import { cn } from "@/lib/cn"

/** The company's site; HIIS is the company, DevSMS its product (DV-157). */
export const HIIS_WEBSITE = "https://www.hiis.io"

/**
 * "DevSMS by HIIS" with the HIIS badge, linking the company's site. The
 * badge is the HIIS brand kit's `logo.svg`, served from `public/brand/hiis`
 * unaltered: the kit forbids recolouring or variants, and its white disc
 * reads on light and dark grounds alike. `compact` keeps the badge alone,
 * for the collapsed sidebar rail.
 */
export function HiisMark({
  className,
  compact = false,
}: {
  className?: string
  compact?: boolean
}) {
  const { t } = useTranslation("common")
  return (
    <a
      href={HIIS_WEBSITE}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "inline-flex items-center gap-2 rounded-md text-xs font-medium opacity-80 transition-opacity hover:opacity-100 focus-visible:opacity-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        className,
      )}
      aria-label={t("hiis.label")}
    >
      <img src="/brand/hiis/logo.svg" alt="" width={20} height={20} className="size-5 shrink-0" />
      {compact ? null : <span className="truncate">{t("hiis.byline")}</span>}
    </a>
  )
}
